import {Active, Over} from '@dnd-kit/core';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

export type PhotoGuideDropIntent = 'before' | 'onto' | 'after';

// The outer quarters of a layout tile insert next to it; the middle half drops onto it.
const EDGE_ZONE_RATIO = 0.25;

/**
 * Where a photo dragged over a Guide Layout tile lands: into the tile (assigning the slot) or
 * between tiles (as an Extra Photo). Decided by where the dragged tile's centre is over the tile.
 */
export const resolvePhotoGuideDropIntent = (active: Active, over: Over) => {
  const activeRect = active.rect.current.translated;
  if (isNil(activeRect) || over.rect.width <= 0) {
    return 'onto';
  }

  const activeCenterX = activeRect.left + activeRect.width / 2;
  const ratio = (activeCenterX - over.rect.left) / over.rect.width;

  return match(ratio)
    .returnType<PhotoGuideDropIntent>()
    .when(
      (value) => value < EDGE_ZONE_RATIO,
      () => 'before'
    )
    .when(
      (value) => value > 1 - EDGE_ZONE_RATIO,
      () => 'after'
    )
    .otherwise(() => 'onto');
};
